import { whiteMailSlice } from '@s/white-mail/slice';

export const Actions = {
  ...whiteMailSlice.actions,
};
